import Debug from 'debug';
import moment from 'moment-timezone';
const debug = Debug(`knack.core.helpers.entry.sanitizeDate`);
export const sanitizeDate = (entry, value, format, solr_base) => {
    if (!value) {
        return value;
    }
    if (value.date || value.hours) {
        var date_val = (value.date) ? value.date : ``;
        if (value.hours) {
            const time_val = `${value.hours}:${value.minutes} ${value.am_pm}`;
            date_val = (date_val) ? `${date_val} ${time_val}` : `01/01/2012 ${time_val}`;
        }
    }
    if (moment(new Date(date_val))._d !== `Invalid Date` && format.date_format !== `Ignore Date`) {
        value = `${moment(new Date(date_val)).format(`YYYY-MM-DDTHH:mm:ss`)}Z`;
        // when this was in Server/models/Entry.js it had reference to "this"
        // this.solr_values[solr_base + '_date'] = value;
        entry.solr_values[`${solr_base}_date`] = value;
    }
    else if (format.date_format === `Ignore Date`) {
        // its just a time, so use an arbitrary date so we can sort and such
        value = `${moment(new Date(date_val)).format(`YYYY-MM-DDTHH:mm:ss`)}Z`;
        // when this was in Server/models/Entry.js it had reference to "this"
        // this.solr_values[solr_base + '_date'] = value;
        entry.solr_values[`${solr_base}_date`] = value;
    }
    return value;
};
